import { useQuery } from '@tanstack/react-query'

import { verifyPcJwtSso } from '@src/api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchVerifyPcJwtSso = (isPresident: boolean) => {
  const { axiosInstance } = useAxios({ apiType: 'IAM' })

  return useQuery({
    enabled: isPresident,
    queryFn: () => verifyPcJwtSso(axiosInstance),
    queryKey: [REACT_QUERY_CACHE_KEYS.VERIFY_PC_JWT_SSO],
  })
}
